import React from "react";
import PrincipalInvestigator from "./CurrentMembers/PrincipalInvestigator";
import PhdScholar from "./CurrentMembers/PhdScholar";
import Mtech from "./CurrentMembers/Mtech";
import Btech from "./CurrentMembers/Btech";
import ProjectScientist from "./CurrentMembers/ResearchAssociate";
import AdministrativeAssistant from "./CurrentMembers/AdministrativeAssistant";
import SideBar from "./SideBar";

const CurrentMembers = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar currentMembers = {true}/>
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5"> Current Members </div>
          <hr />
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                className="nav-item nav-link active"
                id="nav-principalInvestigator-tab"
                data-bs-toggle="tab"
                href="#nav-principalInvestigator"
                role="tab"
                aria-controls="nav-principalInvestigator"
                aria-selected="true"
              >
                Principal Investigator
              </a>
              <a
                className="nav-item nav-link"
                id="nav-projectScientist-tab"
                data-bs-toggle="tab"
                href="#nav-projectScientist"
                role="tab"
                aria-controls="nav-projectScientist"
                aria-selected="false"
              >
  
                Ph. D. Scholar
              </a>
              <a
                className="nav-item nav-link"
                id="nav-mtech-tab"
                data-bs-toggle="tab"
                href="#nav-mtech"
                role="tab"
                aria-controls="nav-mtech"
                aria-selected="false"
              >
                M.S./M.Tech /Dual Degree
              </a>
              <a
                className="nav-item nav-link"
                id="nav-btech-tab"
                data-bs-toggle="tab"
                href="#nav-btech"
                role="tab"
                aria-controls="nav-btech"
                aria-selected="false"
              >
                B.Tech
              </a>
              <a
                className="nav-item nav-link"
                id="nav-administrativeAssistant-tab"
                data-bs-toggle="tab"
                  href="#nav-administrativeAssistant"
                role="tab"
                aria-controls="nav-administrativeAssistant"
                aria-selected="false"
              >
                Research Associate
              </a>
              <a
                className="nav-item nav-link"
                id="nav-phdScholar-tab"
                data-bs-toggle="tab"
                href="#nav-phdScholar"
                role="tab"
                aria-controls="nav-phdScholar"
                aria-selected="false"
              >
                Administrative Assistant
              </a>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="nav-principalInvestigator"
              role="tabpanel"
              aria-labelledby="nav-principalInvestigator-tab"
            >
              <div className="my-4">
                <PrincipalInvestigator />
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-projectScientist"
              role="tabpanel"
              aria-labelledby="nav-projectScientist-tab"
            >
              <div className="my-4">
                <PhdScholar />
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-mtech"
              role="tabpanel"
              aria-labelledby="nav-mtech-tab"
            >
              <div className="my-4">
                <Mtech />
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-btech"
              role="tabpanel"
              aria-labelledby="nav-btech-tab"
            >
              <div className="my-4">
                <Btech />
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-administrativeAssistant"
              role="tabpanel"
              aria-labelledby="nav-administrativeAssistant-tab"
            >
            <div className="my-4">
                <ProjectScientist />
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-phdScholar"
              role="tabpanel"
              aria-labelledby="nav-phdScholar-tab"
            >
              <div className="my-4">
                <AdministrativeAssistant />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentMembers;
